<template>
	<p class="eia-paragraph">
		<slot></slot>
	</p>
</template>

<script>
export default {
	name: 'eia-paragraph',
};
</script>

<style lang="scss" scoped>
.eia-paragraph {
	font-family: $font-family;
	font-size: $text-body;
	margin: 1em 0;
	line-height: 1.4em;
}
</style>
